module.exports = __webpack_public_path__ + "static/media/sculpture2.35b7e733.jpg";